<template>
  <div class="px-1">
    <div class="row">
      <div class="col font-weight-semibold">Data Source</div>
      <div class="col font-weight-semibold">Last Entry</div>
      <div class="col-auto"><span class="fa fa-plus opacity-0" /></div>
    </div>
    <DataEntryItem v-for="form in manualForms" :key="form.id" :form="form" :participant="participant" @updateLastEntry="updateLastEntry"/>
  </div>
</template>

<script>
import DataEntryItem from "../DataEntryItem.vue";

export default {
  name: "DataEntryDrawer",
  components: {
    DataEntryItem
  },
  props: {
    participant: {
      type: Object,
      required: true
    },
    forms: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      manualForms: this.forms
        .map(form => {
          return {
            ...form,
            last_entry: "loading",
          }
        })
    }
  },
  methods : {
    updateLastEntry(source_id, as_of) {
      this.manualForms.find(f => Number(f.id) === Number(source_id)).last_entry = as_of;
    }
  }
}
</script>

<style scoped>

</style>
